/**
 *
 * Asynchronously loads the component for StudentSummary
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const StudentSummary = lazyLoad(
  () => import('./index'),
  module => module.StudentSummary,
);
